module.exports = __webpack_public_path__ + "static/media/siddharth-vijayawada-trip-05.2045b930.png";